export default {
  buttons: {
    start: "Inizia a preparare l'ordine programmato",
  },
};
